import * as Yup from 'yup';
import { StepOriginalProductionSiteForm } from './step-original-production-site-types';

export const stepOriginalProductionSiteSchema = () =>
  Yup.object<StepOriginalProductionSiteForm>().shape({
    originalProductionSite: Yup.mixed().nullable().required('Povinné pole'),
  });
